import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Badge from '@material-ui/core/Badge';

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import DeleteButton from "../../components/Form/DeleteButton";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';

const UserIndex = ({classes, items}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('user.title')}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('user.add'),
                    href: '/users/create',
                }
            ]}
        />

        <Paper className={classes.paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">{i18n.get('user.form.name')}</TableCell>
                        <TableCell scope="col">{i18n.get('user.form.email')}</TableCell>
                        <TableCell scope="col">{i18n.get('user.form.roles')}</TableCell>
                        <TableCell scope="col">{i18n.get('user.form.created_at')}</TableCell>
                        <TableCell scope="col">{i18n.get('user.form.updated_at')}</TableCell>
                        <TableCell scope="col">{i18n.get('user.form.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map(user => (
                        <TableRow key={user.id}>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>
                                {user.roles.map(role => (
                                    <span key={role.id} className={'d-block'}>
                                        <Badge
                                            badgeContent={i18n.get('user.role.'+ role.name)}
                                            classes={{badge: classes.roleBadge }}
                                            children={''}
                                        />
                                    </span>
                                ))}
                            </TableCell>
                            <TableCell>{user.created_at}</TableCell>
                            <TableCell>{user.updated_at}</TableCell>
                            <TableCell>
                                <IconButton
                                    component="a"
                                    href={`/users/${user.id}/edit`}
                                >
                                    <Icon>edit</Icon>
                                </IconButton>

                                <DeleteButton
                                    confirmMessage={i18n.get('user.delete.confirm')}
                                    successMessage={i18n.get('user.delete.success')}
                                    errorMessage={i18n.get('user.delete.error')}
                                    href={`/users/${user.id}`}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>

                <Pagination colSpan={6}/>
            </Table>
        </Paper>
    </Layout>
);

const styles = theme => ({
    role: {
        paddingRight: theme.spacing.unit * 2,
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    roleBadge: {
        backgroundColor: "#bdbdbd",
        color: "black",
        fontWeight: "normal",
        height: 'auto',
    },
    adminBadge: {
        backgroundColor: "#007bff",
    },
    operatorBadge: {
        backgroundColor: "#17a2b8",
    },
    salesBadge: {
        backgroundColor: "#28a745",
    },
    monteurBadge: {
        backgroundColor: "#ffc107",
        color: "#333333",
    },
    companyBadge: {
        backgroundColor: "#dc3545",
    },
});

export default withStyles(styles)(
    withPaginator('users')(UserIndex)
);
